import Recommendations from "./recommendations";
import { supportsPassiveEvents } from "detect-it";
import Carousel from "./carousel";
import { gsap } from "gsap/all";
import ScrollTrigger from "gsap/ScrollTrigger";
import { throttle } from "lodash";
gsap.registerPlugin(ScrollTrigger);

class Courses {
  constructor() {
    this.init = this.init.bind(this);
    this.recommendationListeners = this.recommendationListeners.bind(this);
    this.parallax = this.parallax.bind(this);
    this.listenScroll = this.listenScroll.bind(this);
    this.scrollCallback = this.scrollCallback.bind(this);
  }

  init() {
    console.log("Init Attractions");

    this.recommendationListeners();

    const carou = new Carousel();
    carou.init();

    this.parallax();

    this.stickyMap();

    this.listenScroll();

    if (window.attractionMap) {
      this.hideMapMobile();
    } else {
      window.addEventListener("mapReady", () => {
        console.log("Map ready");
        this.hideMapMobile();
      });
    }
  }

  listenScroll() {
    this.map = document.querySelector("#map-section");
    this.stickyMapBubble = document.querySelector(
      ".sticky-map-bubble__container"
    );

    this.hiddenMapBubble = false;

    // const thro = throttle(this.scrollCallback, 50);
    // window.addEventListener('scroll', thro, supportsPassiveEvents ? { passive: true, capture: false } : false);
  }

  scrollCallback() {
    const mq = window.matchMedia("(min-width: 768px)");
    if (!mq.matches) {
      // Mobile
      // Should hide/show the sticky map button on scroll down to the map section.
      const mapFromTop =
        this.map.getBoundingClientRect().top -
        window.innerHeight +
        window.scrollY;
      if (window.scrollY > mapFromTop && !this.hiddenMapBubble) {
        this.hiddenMapBubble = true;
        gsap.to(this.stickyMapBubble, {
          opacity: 0,
          display: "none",
        });
      } else if (window.scrollY < mapFromTop && this.hiddenMapBubble) {
        this.hiddenMapBubble = false;
        gsap.to(this.stickyMapBubble, {
          display: "block",
          opacity: 1,
        });
      }
    }
  }

  stickyMap() {
    const btn = document.body.querySelector(".sticky-map-bubble");

    btn.addEventListener("click", function () {
      const mapWrapper = document.body.querySelector("#map-section");
      // remove hidden class from mapWrapper
      mapWrapper.classList.remove("hidden");
      window.attractionMap.toggleFullscreen();

      const markerCoords = [];

      window.attractionMap.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          markerCoords.push(layer.getLatLng());
        }
      });

      if (markerCoords.length > 0) {
        const bounds = L.latLngBounds(markerCoords);
        window.attractionMap.fitBounds(bounds, { padding: [40, 40] });
      }
    });
  }

  hideMapMobile() {
    console.log("Hide map mobile");
    const mapWrapper = document.body.querySelector("#map-section");

    if (mapWrapper) {
      // hide map on mobile when exiting leaflet fullscreen
      window.attractionMap.on("exitFullscreen", function () {
        console.log("Fullscreenchange");
        if (window.matchMedia("(max-width: 767px)").matches) {
          mapWrapper.classList.add("hidden");
        }
      });
    }
  }

  parallax() {
    console.log("Parallax");

    ScrollTrigger.matchMedia({
      "(min-width: 200px) and (max-width: 767px)": function () {
        gsap.to(".scroll-trigger-top", {
          y: -60,
          scrollTrigger: {
            trigger: "#attractions-top",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });

        gsap.to(".top-info", {
          y: -100,
          scrollTrigger: {
            trigger: "#attractions-top",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });
        gsap.to(".breadcrumb-list", {
          y: -120,
          scrollTrigger: {
            trigger: "#attractions-top",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });
      },
      "(min-width: 768px)": function () {
        gsap.to(".scroll-trigger-top", {
          y: -150,
          scrollTrigger: {
            trigger: "#attractions-top",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });

        gsap.to(".breadcrumb-list", {
          y: -160,
          scrollTrigger: {
            trigger: "#attractions-top",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });

        gsap.to(".top-info", {
          y: -100,
          scrollTrigger: {
            trigger: "#attractions-top",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });

        gsap.to(".top-bottom-info", {
          y: -60,
          scrollTrigger: {
            trigger: "#attractions-top",
            start: "top top",
            end: "bottom top",
            scrub: 1,
          },
        });

        // const contrasts = gsap.utils.toArray('.contrasted');
        // contrasts.forEach(box => {
        // 	const prev = box.previousElementSibling;
        // 	gsap.to(prev, {
        // 		y: -70,
        // 		scrollTrigger: {
        // 		trigger: prev,
        // 				start: 'top top+=50%',
        // 				end: 'bottom top',
        // 		scrub: true
        // 		}
        // 	});
        // 	const images = box.querySelectorAll('.mediacontainer');
        // 	images.forEach((img, i) => {
        // 		gsap.fromTo(img, {y: 20}, {
        // 			y: -(2 * (i + 1)),
        // 			delay: i,
        // 			scrollTrigger: {
        // 				trigger: img,
        // 				scrub: true
        // 			}
        // 		});
        // 	});
        // });
      },
    });
  }

  recommendationListeners() {
    const btns = document.body.querySelectorAll("#action-recommend");

    const recommendations = new Recommendations();
    btns.forEach((btn, i) => {
      btn.addEventListener("click", recommendations.chechRecommendStatus);
    });
  }
}

export default Courses;
